import { Hero } from "@/components/home/Hero";
import { Marquee } from "@/components/home/Marquee";
import { Manifesto } from "@/components/home/Manifesto";
import { FinalCta } from "@/components/home/FinalCta";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Hero />
      <Marquee />
      <Manifesto />
      <FinalCta />
    </div>
  );
}
